import { Injectable } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';
import { throwError } from 'rxjs';

export const CARREGAR = 'carregar';
export const ATUALIZAR = 'atualizar';
export const SALVAR = 'salvar';
export const ENVIAR = 'enviar';

@Injectable({
  providedIn: 'root'
})
export class ErrorsService {

  constructor() { }

  handleError(response, method) {
    //console.log("response", response);
    let errorMessage = `Ocorreu um erro ao tentar ${method} os dados.\n\n`;
    if (response.error instanceof ErrorEvent) {
      errorMessage += `Client Side! \nError: ${response.error.message}`;
    } else {
      errorMessage += `Server Side! \nError Code: ${response.status}\nMessage: ${response.message}`;
    }
    alert(errorMessage);
    return throwError(errorMessage);
  }

  //TODO - avaliar envio para paginas de erro de acordo com o código da mensagem. Ex: Acesso negado, Login, Home
  handleServerSideError(error: HttpErrorResponse) {
    switch (error.status) {
      case 0:
        alert(`Error Code: ${error.status}\nMessage: ${error.message}`);
        break;
      case 400:
        alert(`Error Code: ${error.status}\nMessage: ${error.message}`);
        break;
      case 401:
        alert(`Error Code: ${error.status}\nMessage: ${error.message}`);
        break;
      case 403:
        alert(`Error Code: ${error.status}\nMessage: ${error.message}`);
        break;
      case 405:
        alert(`Error Code: ${error.status}\nMessage: ${error.message}`);
        break;
      case 408:
        alert(`Error Code: ${error.status}\nMessage: ${error.message}`);
        break;
      case 500:
        alert(`Error Code: ${error.status}\nMessage: ${error.message}`);
        break;
      case 503:
        alert(`Error Code: ${error.status}\nMessage: ${error.message}`);
        break;
      default:
        break;
    }
  }
}
